/* @flow */
/* Do not edit - Generated by iconify. See README.md for more details. */
/* eslint-disable max-len */
import type { ElementConfig as ReactElementConfig } from "react"

import BaseIcon from "./BaseIcon";

export default class SvgIconThings extends BaseIcon {
    static defaultProps: ReactElementConfig<typeof BaseIcon> = {
        iconClass: "ThingsIcon",
    }

    svgContent: string = `
        <svg class='${this.classNames}' viewbox="0 0 64 64" xmlns="http://www.w3.org/2000/svg"><g><rect height="64" fill="none" width="64"></rect><polyline points="42.72 14.38 40.84 14.61 29.87 15.93 31.49 61.25 42.23 61.07 43.43 28.25 51.41 60.3 61.89 58.25 53.92 13.04 42.72 14.38" fill="#4a8cd3"></polyline><path d="M20.4,2a9,9,0,0,0-4.35,1.7L3.24,12.42l5.85,8.7,4-2.58-3,24.2,20.89,2.61L29.87,15.92l11-1.32,1.88-.23L47,13.87,40.7,6.75s-2-2.52-4.2-2.8h-.1c-.59.62-3.47,3.43-7.31,3.43a7.83,7.83,0,0,1-1-.06C23.8,6.77,21.37,2.81,20.92,2h-.1L20.4,2" fill="#7dc7dd"></path><polyline points="46.98 13.87 42.72 14.38 40.84 14.61 29.87 15.93 30.92 45.35 36.92 46.1 39.94 21.9 43.15 25.37 50.96 18.39 46.98 13.87" fill="#68bae0"></polyline></g></svg>
    `;
}
